import { INFO } from './info';
import { INVOICE } from './invoice';
import { PLANS } from './plans';
import { FOOTER } from './footer';
import { OTP } from './otp';
import { GENERAL } from './general';
import { ERROR } from './error';

export const CONSTANTS = {
  INFO,
  INVOICE,
  PLANS,
  FOOTER,
  OTP,
  GENERAL,
  ERROR,
};
